import { Disposer } from "../Infra/Disposer";
import { NamedRoutes } from "./NamedRoutes";
export class ClearIAL2LoginViewModel {
    constructor(container) {
        this.container = container;
        this.disposer = new Disposer();
        this.clearAuthManager = container.clearAuthManager;
        this.routingUIManager = container.routingUIManager;
    }
    run() {
        this.disposer.reaction(() => this.clearAuthManager.state, () => {
            if (this.clearAuthManager.hasCompletedAuth) {
                const clearAuthData = this.clearAuthManager.getClearAuthData();
                if (!(clearAuthData === null || clearAuthData === void 0 ? void 0 : clearAuthData.callbackHash)) {
                    console.error("No clear auth data or hash found");
                    this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_PATIENT);
                    return;
                }
                window.location.hash = clearAuthData.callbackHash;
            }
        }, { fireImmediately: true, name: "ClearIAL2LoginViewModel_smartAuthManagerState" });
    }
    stop() {
        this.disposer.dispose();
    }
}
